import React, { PureComponent } from 'react';
import { Select } from 'lego-on-react';
import b from 'b_';

import './themes-select.css';

import Theme from '@interfaces/themes';

interface Props {
    className?: string;
    themes: Theme[];
    selectedTheme: string | null;
    onThemeChange(themeSlug?: string): void;
}

const class_ = b.with('themes-select');
const placeholder = 'All themes';

export default class ThemesSelect extends PureComponent<Props> {
    public onChange = (values: string[]) => {
        const [value] = values;

        this.props.onThemeChange(value || undefined);
    };

    public render() {
        const { selectedTheme, themes, className = '' } = this.props;
        const items = [{ id: 0, title: placeholder, slug: undefined }, ...themes];

        return (
            <div className={`${class_()} ${className}`}>
                <Select
                    placeholder={placeholder}
                    cls={class_('select')}
                    val={selectedTheme || placeholder}
                    theme="normal"
                    type="radio"
                    size="xs"
                    onChange={this.onChange}
                >
                    {items.map((item: any) => (
                        <Select.Item
                            key={item.id}
                            val={item.slug}
                        >
                            {item.title}
                        </Select.Item>
                    ))}
                </Select>
            </div>
        );
    }
}
